export default "__VITE_ASSET__DSW6UqhP__"